var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusCustom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 394,
    viewBox: "0 0 397 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.376 22.9389C265.376 22.9389 199.481 -1.60093 135.566 35.3361C71.6428 72.2813 40.0835 146.812 12.9341 206.499C-14.2234 266.186 2.59504 327.449 52.0979 355.922C101.593 384.386 134.507 343.763 203.44 342.638C272.372 341.513 291.039 351.768 347.76 312.885C404.49 274.002 413.671 180.605 367.674 110.827C321.678 41.0503 265.376 22.9471 265.376 22.9471V22.9389Z",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M265.376 22.9389C265.376 22.9389 199.481 -1.60093 135.566 35.3361C71.6428 72.2813 40.0835 146.812 12.9341 206.499C-14.2234 266.186 2.59504 327.449 52.0979 355.922C101.593 384.386 134.507 343.763 203.44 342.638C272.372 341.513 291.039 351.768 347.76 312.885C404.49 274.002 413.671 180.605 367.674 110.827C321.678 41.0503 265.376 22.9471 265.376 22.9471V22.9389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.386 216.705L313.173 227.916L324.386 239.126L335.599 227.916L324.386 216.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5272 18.5615L71.3141 29.7717L82.5271 40.9819L93.7402 29.7717L82.5272 18.5615Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1446 252.33L55.2112 259.262L62.1446 266.194L69.078 259.262L62.1446 252.33Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9579 139.827L16.0245 146.758L22.9579 153.69L29.8913 146.758L22.9579 139.827Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.445 59.5968L299.512 66.5284L306.445 73.4601L313.379 66.5284L306.445 59.5968Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.704 260.038L67.8439 269.895L77.704 279.753L87.5641 269.895L77.704 260.038Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.343 249.528L267.409 256.459L274.343 263.391L281.276 256.459L274.343 249.528Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.526 45.4388L314.257 58.7041L327.526 71.9694L340.794 58.7041L327.526 45.4388Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.325 358.675L178.392 365.606L185.325 372.538L192.258 365.606L185.325 358.675Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2527 149.554C52.8177 149.554 57.329 145.044 57.329 139.48C57.329 133.917 52.8177 129.407 47.2527 129.407C41.6877 129.407 37.1764 133.917 37.1764 139.48C37.1764 145.044 41.6877 149.554 47.2527 149.554Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.499 180.342C344.755 180.342 349.016 176.082 349.016 170.826C349.016 165.571 344.755 161.311 339.499 161.311C334.242 161.311 329.981 165.571 329.981 170.826C329.981 176.082 334.242 180.342 339.499 180.342Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.653 110.934C376.746 110.934 379.254 108.427 379.254 105.335C379.254 102.242 376.746 99.7356 373.653 99.7356C370.56 99.7356 368.052 102.242 368.052 105.335C368.052 108.427 370.56 110.934 373.653 110.934Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.68 32.0192C261.68 30.1637 260.177 28.6613 258.321 28.6613C256.465 28.6613 254.963 30.1637 254.963 32.0192C254.963 33.8746 256.465 35.3771 258.321 35.3771C260.177 35.3771 261.68 33.8746 261.68 32.0192Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.595 226.794C122.45 226.794 123.954 225.291 123.954 223.436C123.954 221.582 122.45 220.078 120.595 220.078C118.74 220.078 117.237 221.582 117.237 223.436C117.237 225.291 118.74 226.794 120.595 226.794Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0936 318.591C43.8784 318.591 46.1359 316.334 46.1359 313.55C46.1359 310.766 43.8784 308.509 41.0936 308.509C38.3088 308.509 36.0513 310.766 36.0513 313.55C36.0513 316.334 38.3088 318.591 41.0936 318.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.216 305.159C346.216 302.688 344.212 300.685 341.74 300.685C339.269 300.685 337.265 302.688 337.265 305.159C337.265 307.63 339.269 309.634 341.74 309.634C344.212 309.634 346.216 307.63 346.216 305.159Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.386 15.788C310.386 13.3167 308.383 11.3135 305.911 11.3135C303.439 11.3135 301.435 13.3167 301.435 15.788C301.435 18.2592 303.439 20.2624 305.911 20.2624C308.383 20.2624 310.386 18.2592 310.386 15.788Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.23 187.616L99.3177 204.972",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7641 93.0281L104.918 106.46",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.636 16.9045L133.472 52.1667",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.096 1.23157L184.979 29.2196",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92 67.8397L278.474 39.2933",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.667 125.491L314.304 117.092",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.156 188.174L286.875 199.931",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36 67.2814L121.154 80.1547",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.192 91.345L267.273 99.7438",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.519 152.354L91.4833 157.953",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.998 159.628L282.95 161.869",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66 126.303C278.499 124.111 266.566 126.057 259.019 132.141C251.472 138.224 249.773 140.416 249.773 140.416C249.773 140.416 246.365 116.566 246.365 115.835C246.365 115.105 241.495 70.3272 240.526 63.7592C239.548 57.1911 238.095 47.454 236.633 45.2619C235.171 43.0699 229.333 42.8318 227.386 43.8006L225.44 44.7776C225.44 44.7776 226.417 27.7417 224.463 23.6038C222.516 19.466 216.431 21.9044 214.723 24.0882C213.023 26.2803 211.8 29.6875 211.8 29.6875C211.8 29.6875 206.199 27.7417 203.037 34.0717C199.876 40.4016 197.437 45.9926 196.952 52.0763C196.468 58.1599 193.79 65.9513 193.79 65.9513C193.79 65.9513 190.629 60.8446 187.221 63.7592C183.813 66.682 179.92 78.1185 178.943 86.3943C177.966 94.67 176.996 116.566 176.996 116.566C176.996 116.566 175.05 126.541 174.073 134.571C173.096 142.6 173.827 175.941 177.481 189.808C181.135 203.683 185.997 212.443 185.997 212.443C185.997 212.443 194.513 240.431 195.737 244.323C196.952 248.214 210.338 301.268 210.338 301.268L250.257 250.653C250.257 250.653 240.279 223.157 238.087 216.827C235.894 210.497 234.432 208.552 234.432 208.552C234.432 208.552 246.603 191.269 253.172 186.163C259.742 181.056 263.15 164.02 264.858 156.475C266.558 148.93 273.621 138.471 277.513 135.063C281.406 131.656 284.814 128.495 281.652 126.303H281.66ZM191.598 114.629C190.867 114.629 191.113 105.138 191.113 93.7012C191.113 82.2646 193.059 77.1498 193.059 77.1498C192.082 82.2564 194.037 107.568 194.037 109.276C194.037 110.983 192.337 114.629 191.606 114.629H191.598Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.405 212.714C231.451 211.171 232.001 209.529 232.001 209.529",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.499 207.098C204.499 207.098 217.885 215.859 224.463 214.159",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.773 140.425C249.773 140.425 244.665 148.454 243.441 151.377C242.226 154.3 241.495 156.73 239.302 157.945C237.109 159.16 234.194 160.868 234.194 160.868",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.065 142.797C228.873 145.671 220.16 150.753 215.208 158.183",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.226 139.932C242.226 139.932 240.444 140.49 237.734 141.623",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.53 161.352C212.53 161.352 208.145 169.381 206.199 175.711",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8 29.6957C211.8 29.6957 210.584 39.9172 208.876 55.2453C207.176 70.5735 206.199 78.1185 206.445 87.8556C206.692 97.5927 209.369 106.107 209.122 107.322",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.432 44.7858C225.432 44.7858 224.701 51.1157 225.432 59.3832C226.163 67.659 224.701 82.9871 224.701 88.8327C224.701 94.6782 224.947 103.43 225.185 106.107C225.424 108.783 226.885 110.729 226.885 110.729",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.055 112.19C230.055 112.19 231.271 114.382 239.302 114.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.553 106.353C211.553 106.353 217.392 107.568 221.293 106.837",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.374 116.574C190.374 116.574 190.374 119.005 183.312 121.197",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.253 109.998C204.984 109.514 207.907 108.537 208.638 105.13",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.671 147.28C204.671 147.28 219.806 141.73 229.39 139.71",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.637 393.589H378.49C369.35 381.529 335.992 337.581 333.816 335.413C331.295 332.893 320.192 331.382 320.192 331.382L287.401 304.149L246.537 236.564L207.694 290.529L201.132 264.298L186.498 318.771C186.498 318.771 239.475 383.335 241.487 385.856C241.881 386.348 244.164 389.238 247.629 393.598L247.637 393.589Z",
    fill: "#344054",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.174 204.381C145.174 204.381 134.343 176.647 131.731 171.541C129.12 166.434 114.945 144.259 114.231 138.241C113.517 132.223 111.299 122.215 109.016 118.028C106.733 113.84 113.533 111.098 119.158 116.402C124.775 121.706 128.175 130.334 128.101 132.822C128.027 135.31 140.715 144.603 140.715 144.603L143.023 123.225C143.023 123.225 145.486 70.1959 144.969 62.2814C144.452 54.3669 143.943 37.5609 150.225 36.9123C156.507 36.2637 157.484 41.2308 157.484 41.2308C157.484 41.2308 157.706 28.7105 164.695 29.5151C170.033 30.1308 172.077 35.1636 172.858 37.5856C173.638 40.0075 174.557 43.0124 174.557 43.0124C174.557 43.0124 178.959 40.0239 183.254 47.142C185.718 51.2307 190.957 64.0876 191.803 67.3552C192.649 70.6228 192.912 71.805 192.912 71.805C192.912 71.805 198.8 71.6162 201.411 77.8312C204.023 84.0462 207.735 100.261 211.323 113.676C214.912 127.091 214.764 139.833 214.764 139.833C214.764 139.833 216.168 182.994 213.278 196.721C210.387 210.448 204.951 222.147 203.834 223.264C202.717 224.38 186.654 271.769 186.654 271.769L130.943 251.121C130.943 251.121 142.546 222.624 144.378 216.409C146.217 210.202 145.174 204.381 145.174 204.381Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.521 163.93C133.636 166.647 134.219 168.281 134.219 168.281",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.015 146.968C139.015 146.968 135.87 150.63 134.236 157.165C133.907 158.478 133.71 159.71 133.603 160.843",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.484 41.2472C157.484 41.2472 158.453 58.4472 159.094 66.9446C159.743 75.442 160.055 88.5863 160.112 97.2233C160.17 105.852 159.119 116.706 158.527 119.062C157.936 121.418 156.622 124.423 156.622 124.423",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.549 43.0288C174.549 43.0288 171.798 46.2307 172.71 50.3522C173.621 54.4736 177.851 77.4946 177.851 80.8278C177.851 84.1611 178.089 113.126 178.146 115.088C178.212 117.051 176.832 123.651 176.175 126.27",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.903 71.8132C192.903 71.8132 189.766 72.1334 190.481 77.043C191.195 81.9526 192.756 97.9048 192.747 102.346C192.747 106.796 193.782 117.059 193.577 126.738C193.372 136.418 195.597 139.751 196.64 142.239",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.452 136.377C144.452 136.377 143.335 141.935 144.838 144.809C146.341 147.691 148.426 153.766 148.426 157.107",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.702 133.643C155.702 133.643 155.111 138.216 155.76 141.163C156.409 144.111 158.437 147.116 158.437 147.116",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.467 140.851C174.467 140.851 173.81 145.687 174.984 148.766C176.159 151.836 177.53 154.127 177.53 154.127",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.207 393.59L201.001 276.752C201.001 276.752 178.902 258.51 164.366 248.937C149.831 239.364 132.396 239.651 132.396 239.651C132.396 239.651 109.64 288.131 108.45 291.218C107.251 294.305 91.3848 327.154 91.3848 327.154C91.3848 327.154 84.4127 329.641 81.3167 335.208C78.8941 339.576 61.4105 377.416 53.962 393.59H149.207Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.852 284.422C188.148 283.064 188.908 280.104 187.551 277.809C186.193 275.514 183.232 274.754 180.936 276.111C178.641 277.468 177.881 280.429 179.238 282.724C180.596 285.019 183.557 285.779 185.852 284.422Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.79 299.494C180.142 302.08 177.522 303.649 174.935 303C172.348 302.351 170.78 299.732 171.429 297.146C172.077 294.56 174.697 292.992 177.284 293.64C179.871 294.289 181.439 296.908 180.79 299.494Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 397,
    height: 394,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusCustom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/statusCustom.24f42ae52388155db18b1ded5e52cc8b.svg";